<template>
 <div>
  <div class="body-wrapper" v-if="statusCode">
    <div class="container-fluid">
      <div class="card card-body">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="d-sm-flex align-items-center justify-space-between">
              <h4 class="fw-semibold fs-4 mb-4 mb-md-0 card-title">{{ (user_name) ? 'Coleta - Codigo #' + this.codeSend : '' }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">Informações</h4>
              <div class="row">
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="weight">Código</label>
                    <p type="text">{{ code }}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label" for="weight">Responsável no Local</label>
                    <p type="text">{{responsible}}</p>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="weight">Peso da carga (KG)</label>
                    <p type="text">{{weight}}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label" for="suitable_date">Data para coletar</label>
                    <p type="text">{{datePickup}}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label" for="user_id">Cliente</label>
                    <p type="text">{{user_name}}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label" for="address_id">Situação</label>
                    <p type="text">{{status}}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label">CEP</label>
                      <p type="text">{{zip_code}}</p>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label">Rua (Ex.: Rua das neves)</label>
                    <p type="text">{{street}}</p>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label">Número</label>
                    <p type="text">{{street_number}}</p>

                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label">Bairro</label>
                    <p type="text">{{neighbohood}}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label">Cidade</label>
                    <p type="text">{{city}}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label">Estado</label>
                    <p type="text">{{state}}</p>
                  </div>
                </div>
                <h4 class="card-title mb-3 mt-4">Transporte</h4>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label" for="respCollection">Responsável por coletar</label>
                    <p type="text">{{name_truck}}</p>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="rg">RG</label>
                    <p type="text">{{rg_truck}}</p>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="cpf">CPF</label>
                    <p type="text">{{cpf_truck}}</p>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Placa do Caminhão</label>
                    <p type="text">{{license_plate}}</p>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Modelo do Caminhão</label>
                    <p type="text">{{trucker_model}}</p>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Empresa do responsável</label>
                    <p type="text">{{entity_truck}}</p>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Link de rastreio</label>
                    <p type="text">{{tracker_link}}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="main-wrapper" v-else>
      <div class="position-relative overflow-hidden radial-gradient min-vh-100 w-100 d-flex align-items-center justify-content-center">
        <div class="d-flex align-items-center justify-content-center w-100">
          <div class="row justify-content-center w-100">
            <div class="col-md-8 col-lg-6 col-xxl-3">
              <div class="card mb-0 bg-body">
                <div class="card-body">
                  <a href="@/index.html" class="text-nowrap logo-img text-center d-block mb-5 w-100">
                    <img src="@/assets/images/logo_black.png" class="dark-logo" alt="Logo-Dark" />
                  </a>
                  <div>
                    <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label">Informe o codigo de consulta</label>
                      <input type="text" class="form-control" v-model="codeSend">
                    </div>
                    <span @click="consult" class="btn btn-primary w-100 py-8 mb-4 rounded-2">Consultar</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 </div>
</template>

<script>

import Cookies from 'js-cookie';

export default {
  data() {
    return {
      code: '',
      codeSend: '',
      statusCode: false,
      title: null,
      role: 0,
      datePickup: '',
      responsible: '',
      address_id: 0,
      weight: 0,
      name_truck: '',
      rg_truck: '',
      cpf_truck: '',
      license_plate: '',
      trucker_model: '',
      entity_truck: '',
      tracker_link: '',
      user_name: '',
      user_id: 0,
      zip_code: '',
      street: '',
      street_number: '',
      neighbohood: '',
      city: '',
      state: '',
      attach_name: '',
      status: '',
      list: [],
      listAddress: [],
      listStatus: [],
      attachments: [],
      loadingAddress: true,
      loadingClients: true,
    }
  },
  methods: {
    showAlert(type, msg) {
        var textMsg = "";

        if (msg.message) {
            if (typeof msg.errors === 'object' && msg.errors) {
                for (const key in msg.errors) {
                    if (Object.prototype.hasOwnProperty.call(msg.errors, key)) {
                        const errorMessages = msg.errors[key];
                        textMsg += `${errorMessages.join(', ')}<br>`;
                    }
                }
            } else {
                textMsg = `${msg.message}`;
            }
        } else {
            textMsg = `${msg}`;
        }

        this.$swal({
            text: textMsg,
            icon: type,
            confirmButtonText: 'Confirmar',
            html: textMsg
        });
    },
    consult() {
        var json = {
            codeSend: this.codeSend,
        };

        this.$http
        .post("/pickup-consult", json, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        })
        .then(async (response) => {

          if(response.data.status == true) {
            this.item_id = response.data.item.id;
            this.datePickup = response.data.item.collection_orders.suitable_date.date.split(" ")[0];
            this.responsible = response.data.item.collection_orders.responsible;
            this.weight = response.data.item.collection_orders.weight;
            this.name_truck = response.data.item.truck_drivers.name;
            this.rg_truck = response.data.item.truck_drivers.rg;
            this.cpf_truck = response.data.item.truck_drivers.cpf;
            this.license_plate = response.data.item.truck_drivers.license_plate;
            this.trucker_model = response.data.item.truck_drivers.trucker_model;
            this.entity_truck = response.data.item.truck_drivers.entity_truck;
            this.tracker_link = response.data.item.user_id;
            this.user_id = response.data.item.users.id;
            this.user_name = response.data.item.users.individual.name;

            this.zip_code = response.data.item.collection_orders.address.zip_code;
            this.street = response.data.item.collection_orders.address.street;
            this.street_number = response.data.item.collection_orders.address.street_number;
            this.neighbohood = response.data.item.collection_orders.address.neighbohood;
            this.city = response.data.item.collection_orders.address.city;
            this.state = response.data.item.collection_orders.address.state;

            this.status = response.data.item.status.name;
            this.statusCode = true; 
            this.code = response.data.item.code;
          }
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                this.showAlert('error', error.response.data);
            } else {
                this.showAlert('error', 'Ocorreu um erro desconhecido. Entre em contato com a equipe de desenvolvimento.');
            }
        });
    },
    loadAttachment() {
      this.$http.get('/attachment/' + this.item_id, {
        headers: {
          'Authorization': 'Bearer ' + Cookies.get('_token')
        }
      }).then(response => {
        this.attachments = response.data.items;
      }).catch(error => {
        console.log(error)
      });
    },

  },
  created() {

  },
}
</script>
